@if (initialized && dto) {

    @if (uiMode == 'side') {
        <mvs-cn-commission-model-side
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [(activeNavigationItem)]="activeNavigationItem"
                (onNavigationItems)="handleNavigationItems($event)"
        ></mvs-cn-commission-model-side>
    } @else {
        <mvs-cn-commission-model-full
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [(activeNavigationItem)]="activeNavigationItem"
                (onNavigationItems)="handleNavigationItems($event)"
        ></mvs-cn-commission-model-full>
    }

}
